import gql from 'graphql-tag';

export default gql`
  mutation adminDeleteFoodSafetyEntry($foodSafetyEntryId: ID!) {
    adminDeleteFoodSafetyEntry(foodSafetyEntryId: $foodSafetyEntryId)
  }
`;
